module.exports = __webpack_public_path__ + "static/alpha_telegram_art-c4131244ac74b3e02506a577f96ed3c3.png";